/* eslint-disable import/prefer-default-export */

export class DateHelper {
  static isCurrentTimeWithinRange = (
    dailyHappyHourStartTime?: number,
    dailyHappyHourEndTime?: number,
    isHappyHour = true
  ): boolean => {
    if (!dailyHappyHourStartTime && !dailyHappyHourEndTime && !isHappyHour) return true;

    if (!dailyHappyHourStartTime || !dailyHappyHourEndTime) return false;

    const now = new Date();
    const secondsFromStartOfDay =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    return (
      secondsFromStartOfDay >= dailyHappyHourStartTime &&
      secondsFromStartOfDay <= dailyHappyHourEndTime
    );
  };

  static convertSecondsToHoursAndMinutes(seconds: number): {
    hours: number;
    minutes: number;
  } {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    return { hours, minutes };
  }

  static getTimeRemaining(startTime: number, endTime: number) {
    const now = new Date();
    const currentSeconds =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    const remainingSeconds = endTime - currentSeconds;

    if (currentSeconds < startTime) {
      return false;
    }

    if (remainingSeconds < 0) {
      return false;
    }

    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;

    return { hours, minutes, seconds };
  }

  static getTimeLeft(endDate: Date) {
    if (!endDate) return null;
    
    const timeLeft = new Date(endDate).getTime() - new Date().getTime();
    if (timeLeft <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    return { days, hours, minutes, seconds };
  }

  static getCurrentDayNumberInJS() {
    const today = new Date();
    let day = today.getDay(); // getDay() returns 0 (Sunday) to 6 (Saturday)
    if (day === 0) {
      day = 7; // Convert Sunday (0) to 7
    }
    return day;
  }
}
